import { render, staticRenderFns } from "./CreditNoteDetails.vue?vue&type=template&id=1bcebb40&scoped=true&"
import script from "./CreditNoteDetails.vue?vue&type=script&lang=js&"
export * from "./CreditNoteDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteDetails.vue?vue&type=style&index=0&id=1bcebb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcebb40",
  null
  
)

export default component.exports